import { createContext, useContext, useEffect, useState } from "react";

const FavContext = createContext({ ids: [], toggle: () => {}, has: () => false, clear: () => {} });
const KEY = "gw_shortlist";

export function FavouritesProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(ids)); }, [ids]);
  const toggle = (id) => setIds((xs) => (xs.includes(id) ? xs.filter((x) => x !== id) : [...xs, id]));
  const has = (id) => ids.includes(id);
  const clear = () => setIds([]);
  return <FavContext.Provider value={{ ids, toggle, has, clear, setIds }}>{children}</FavContext.Provider>;
}

export const useFavourites = () => useContext(FavContext);
